import { render, staticRenderFns } from "./LinhaDeListaDeDados.vue?vue&type=template&id=9818d4a4&scoped=true"
import script from "./LinhaDeListaDeDados.vue?vue&type=script&lang=js"
export * from "./LinhaDeListaDeDados.vue?vue&type=script&lang=js"
import style0 from "./LinhaDeListaDeDados.vue?vue&type=style&index=0&id=9818d4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9818d4a4",
  null
  
)

export default component.exports